// client/src/components/admin/LegalNameAdmin.js — Maxula
// Bloc admin : nom légal déclaré vs validé + alerte si différence + Corriger & Valider.
import React, { useState } from 'react';
import { FiShield, FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import { toast } from 'react-toastify';
import API from '../../services/api';

export default function LegalNameAdmin({ merchant, onUpdated }) {
  const id = merchant && (merchant.id || merchant._id);
  const declared = (merchant && merchant.declaredLegalName) || '';
  const verified = !!(merchant && merchant.legalNameVerified);
  const [value, setValue] = useState((merchant && merchant.legalName) || declared || (merchant && merchant.businessName) || '');
  const [busy, setBusy] = useState(false);

  const mismatch = declared && value && declared.trim() !== value.trim();

  const submit = async () => {
    if (!id) return;
    setBusy(true);
    try {
      const { data } = await API.put(`/merchants/${id}/legal-name`, { legalName: value });
      toast.success('Nom légal validé');
      if (onUpdated && data && data.data) onUpdated(data.data);
    } catch (e) {
      toast.error('Action impossible');
    } finally { setBusy(false); }
  };

  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 14, marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, marginBottom: 10 }}>
        <FiShield /> Nom légal{' '}
        {verified
          ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#16a34a', fontWeight: 700 }}><FiCheckCircle size={14} /> Vérifié</span>
          : <span style={{ fontSize: 12, color: '#b45309', fontWeight: 700 }}>En cours de vérification</span>}
      </div>
      <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 8 }}>
        Déclaré par le marchand : <strong style={{ color: '#374151' }}>{declared || '—'}</strong>
      </div>
      {mismatch ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '6px 10px', marginBottom: 8 }}>
          <FiAlertTriangle size={14} /> La valeur saisie diffère du nom déclaré — vérifiez les papiers KYC.
        </div>
      ) : null}
      <label style={{ display: 'block', fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Nom légal validé (corrigez selon les papiers KYC)</label>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="Raison sociale / nom légal"
          style={{ flex: '1 1 240px', border: '1px solid #d1d5db', borderRadius: 8, padding: '9px 12px', fontSize: 14 }} />
        <button type="button" onClick={submit} disabled={busy}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 16px', borderRadius: 8, border: 'none', background: '#E11D79', color: '#fff', fontWeight: 700, fontSize: 13, cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.7 : 1, whiteSpace: 'nowrap' }}>
          Corriger &amp; Valider
        </button>
      </div>
    </div>
  );
}
